// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__teT2S","importantInfo":"styles_importantInfo__VtH4r"};